namespace TabAurous.Reports {
    export namespace ShortListCategoryWiseService {
        export const baseUrl = 'Reports/ShortListCategoryWise';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ShortListCategoryWiseRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetVouchers(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Common.Vouchers>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Reports/ShortListCategoryWise/List",
            GetVouchers = "Reports/ShortListCategoryWise/GetVouchers"
        }

        [
            'List', 
            'GetVouchers'
        ].forEach(x => {
            (<any>ShortListCategoryWiseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
